// Debug utility for MCP and OpenAI interactions
export class MCPDebugLogger {
  private static isDebugMode = true; // Always enabled for debugging AI issues

  static log(type: 'mcp_request' | 'mcp_response' | 'openai_request' | 'openai_response' | 'error', data: any, duration?: number) {
    if (!this.isDebugMode) return;

    const event = new CustomEvent('mcp-debug', {
      detail: {
        type,
        data,
        duration,
        timestamp: new Date().toISOString(),
      }
    });

    window.dispatchEvent(event);
  }

  static logMCPRequest(endpoint: string, payload: any) {
    this.log('mcp_request', {
      endpoint,
      payload,
      message: `MCP Request to ${endpoint}`,
    });
  }

  static logMCPResponse(endpoint: string, response: any, duration: number) {
    this.log('mcp_response', {
      endpoint,
      response,
      message: `MCP Response from ${endpoint}`,
    }, duration);
  }

  static logOpenAIRequest(model: string, messages: any[], tools?: any[]) {
    this.log('openai_request', {
      model,
      messages: messages.map(msg => ({
        role: msg.role,
        content: typeof msg.content === 'string' ? msg.content.substring(0, 100) + '...' : msg.content,
      })),
      tools: tools?.map(tool => tool.function?.name) || [],
      message: `OpenAI Request to ${model}`,
    });
  }

  static logOpenAIResponse(model: string, response: any, duration: number) {
    this.log('openai_response', {
      model,
      response: {
        choices: response.choices?.map((choice: any) => ({
          role: choice.message?.role,
          content: choice.message?.content?.substring(0, 100) + '...',
          tool_calls: choice.message?.tool_calls?.map((call: any) => call.function?.name) || [],
        })) || [],
        usage: response.usage,
      },
      message: `OpenAI Response from ${model}`,
    }, duration);
  }

  static logError(context: string, error: any) {
    this.log('error', {
      context,
      error: {
        message: error.message,
        stack: error.stack?.split('\n').slice(0, 3).join('\n'), // First 3 lines of stack
        name: error.name,
      },
      message: `Error in ${context}`,
    });
  }
}

export default MCPDebugLogger;
